import angular from 'angular'

export default angular
  .module('ggs.gallery-retry', [])
  .name
